import { createRequestActionCreators, RequestAction, createAction } from 'helpers/actionsHelpers'
import { OpportunitiesPageType } from 'interfaces/pages'
import { Collection } from 'interfaces'
import { SocialInsight, SocialInnerInsight, WithSocialInsightUid } from 'interfaces/socialInsights'
import { OpportunityPlacement } from 'interfaces/opportunities'
import { CountData } from 'interfaces/feed'
import { SimpleAction } from 'interfaces/action'

type GetSocialInsightsRequest = {
  page: OpportunitiesPageType
}

type GetSocialInsightsResponse = {
  insights: Collection<SocialInnerInsight, 'id'>
  socialInsights: Collection<SocialInsight, 'uid'>
  placements: OpportunityPlacement[]
}

export const GET_SOCIAL_INSIGHTS = 'GET_SOCIAL_INSIGHTS' as const
export type GetSocialInsights = RequestAction<typeof GET_SOCIAL_INSIGHTS, GetSocialInsightsRequest, GetSocialInsightsResponse>
export const getSocialInsightsActionCreator =
  createRequestActionCreators<typeof GET_SOCIAL_INSIGHTS, GetSocialInsightsRequest, GetSocialInsightsResponse>(GET_SOCIAL_INSIGHTS)

type ToggleSocialInsightLikePayload =
  & WithSocialInsightUid
  & {
    toLike: boolean
  }
export const TOGGLE_SOCIAL_INSIGHT_LIKE = 'TOGGLE_SOCIAL_INSIGHT_LIKE' as const
export type ToggleSocialInsightLike = RequestAction<typeof TOGGLE_SOCIAL_INSIGHT_LIKE, ToggleSocialInsightLikePayload, CountData>
export const toggleSocialInsightLikeActionCreator =
  createRequestActionCreators<typeof TOGGLE_SOCIAL_INSIGHT_LIKE, ToggleSocialInsightLikePayload, CountData>(TOGGLE_SOCIAL_INSIGHT_LIKE)

export const CLOSE_REVIEW_COMPOSE_PANE = 'CLOSE_REVIEW_COMPOSE_PANE' as const
type CloseReviewComposePane = SimpleAction<typeof CLOSE_REVIEW_COMPOSE_PANE>
export const closeReviewComposePaneActionCreator = () => createAction(CLOSE_REVIEW_COMPOSE_PANE)

export type SocialInsightsAction =
  | GetSocialInsights
  | ToggleSocialInsightLike
  | CloseReviewComposePane
